import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/layout/Footer.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/layout/Header.jsx");
